function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { checkoutAPI } from "../config";
import fetchVoyado from "../components/voyado";
var getCheckoutOptions = function getCheckoutOptions(token, body, method) {
  var fetchOptions = {
    mode: "cors",
    cache: "no-cache"
  };
  fetchOptions.method = method;
  if (token) fetchOptions.headers = {
    Accept: "application/json, text/plain, */*; api-token:".concat(token)
  };
  if (_typeof(body) === "object" && Object.keys(body).length > 0) {
    fetchOptions.body = JSON.stringify(body);
  }
  return fetchOptions;
};
var fetchCheckout = function fetchCheckout(path, token) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "GET";
  var encodedPath = path.split("/").map(function (part) {
    return encodeURIComponent(part);
  }).join("/");
  return fetch("".concat(checkoutAPI).concat(encodedPath), getCheckoutOptions(token, body, method)).then(function (data) {
    return data.json();
  }).then(function (data) {
    fetchVoyado(path, data, body, method);
    return data;
  }).catch(function (err) {
    return console.log("DEBUG: was not able to be fetched", err);
  });
};
var fetchShop = function fetchShop(uri) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return fetch("".concat(encodeURI(window.rest_object.api_url)).concat(encodeURI(window.sitewide.language).slice(0, 2), "/").concat(encodeURI(uri), "/").concat(encodeURI(param)), {
    method: "GET",
    cache: "no-cache"
  }).then(function (data) {
    if (data.ok) {
      return data.json();
    }
    return Promise.reject(data);
  });
};
export default fetchCheckout;
export { fetchShop };


// WEBPACK FOOTER //
// ./scripts/shop/async.js